// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"50af2fec","239":"4cf379ba","453":"e995ee88","455":"69606757"}[chunkId] + ".chunk.js";
};